import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import type { RouteContext } from 'react-resource-router';
import type { State } from 'state';
import { fetchCompleteSignupModel } from 'state/actions/complete-signup';
import {
    getInitialError,
    getSignupToken,
    getEmailAddress,
    getValidationOutcome,
    getPortalId,
    getRedirectUrl,
    getNewSignupLinkSuccessfullySent,
} from 'state/selectors/complete-signup';
import { getSharedPortalName } from 'state/selectors/help-center';
import { getIsFailedLoginAttempt } from 'state/selectors/login';

import { isLoggedIn } from 'state/selectors/user';
import CompleteSignupComponent from './complete-signup';

type ExternalProps = Omit<RouteContext, 'action'>;

const selector = createSelector(
    (state: State) => getInitialError(state),
    (state: State) => getIsFailedLoginAttempt(state),
    (state: State) => isLoggedIn(state),
    (state: State) => getSignupToken(state),
    (state: State) => getEmailAddress(state),
    (state: State) => getValidationOutcome(state),
    (state: State) => getPortalId(state),
    (state: State) => getRedirectUrl(state),
    (state: State) => getNewSignupLinkSuccessfullySent(state),
    (_: State, props: ExternalProps) => props.location.search,
    (state: State) => getSharedPortalName(state),
    (
        initialError,
        isFailedLoginAttempt,
        userLoggedIn,
        signupToken,
        email,
        validationOutcome,
        portalId,
        redirectUrl,
        newSignupLinkSuccessfullySent,
        locationSearch,
        sharedPortalName
    ) => ({
        signupToken,
        email,
        validationOutcome,
        portalId,
        redirectUrl,
        newSignupLinkSuccessfullySent,
        locationSearch,
        isFailedLoginAttempt,
        helpCenterName: sharedPortalName,
        error: initialError && initialError.error,
        isLoading: email === undefined || email === '',
        isLoggedIn: userLoggedIn,
    })
);

export default connect(selector, {
    fetchCompleteSignupModelAction: fetchCompleteSignupModel,
})(CompleteSignupComponent);
